export const ReportStatus = {
  draft: 'draft',
  under_review: 'under_review',
  approved: 'approved',
  published: 'published',
} as const;

export type ReportStatus = (typeof ReportStatus)[keyof typeof ReportStatus];

export const statusTextMap: Record<ReportStatus, string> = {
  draft: 'Draft',
  under_review: 'Under Review',
  approved: 'Approved',
  published: 'Published',
};

export const statusColorMap: Record<ReportStatus, string> = {
  draft: '#64748b',
  under_review: '#f8b007',
  approved: '#0f9d58',
  published: '#2563eb',
};
export interface ICommentReply {
  id: string;
  authorId: string;
  authorName: string;
  text: string;
  createdAt: string;
}

export interface IReviewerComment {
  id: string;
  authorId: string;
  authorName: string;
  comment?: string;
  text?: string;
  createdAt: string;
  replies?: ICommentReply[];
}

export interface ITimelineEvent {
  time: string;
  event: string;
  severity: 'info' | 'warning' | 'critical';
}

export interface IReport {
  id: string;
  title: string;
  hashtags: string[];
  coverImage: string | null;
  content: string;
  authorId: string;
  authorName: string;
  createdAt: string;
  isDraft: boolean;
  authorAvatar: string;
  status: ReportStatus;
  reviewerId?: string | null;
  reviewerName?: string | null;
  reviewerComments?: IReviewerComment[];
  reviewerComment?: IReviewerComment[];
  timeline?: ITimelineEvent[];
}
